import styled from "styled-components";

const StyledGradientButton = styled.div`        
    display: flex;
    padding: 1px;
    justify-content: center;
    align-items: center;
    background: linear-gradient(#38ef7d, #11998e);
    border-radius: 10px;
    padding: 5px;
    min-width: 120px;
    cursor: pointer;  

    #content {
        color: #FFFFFF;
        font-size: 18px;
        margin: 0px;
    }

    &:hover{
        #content {
            color: #000000;
        }
    }
  `;

function GradientButton({ text, onTap, style }) {

    return (
        <StyledGradientButton onClick={() => onTap()} style={style}>
            <p id="content">
                {text}
            </p>
        </StyledGradientButton>
    );
}

export default GradientButton;
